// @ts-check
import {
  StyledDismiss,
  StyledProviderLogo,
  StyledSyncTeamsCTA
} from './SyncTeamsCTA.style';
import useSyncTeamsCTA from './useSyncTeamsCTA';

import GithubLogo from 'images/logos/github-logo.svg';
import Icon from 'components/base/Icon';
import { LBButton } from '@linearb/buzz';

const SyncTeamsCTA = () => {
  const { redirectToTeamsSettings, shouldShowCTA, dismissCTA } =
    useSyncTeamsCTA();

  if (!shouldShowCTA) return null;

  return (
    <StyledSyncTeamsCTA>
      <StyledProviderLogo src={GithubLogo} />
      <div className='primary'>New! GitHub team synchronization</div>
      <div className='secondary'>
        Connect your GitHub teams to LinearB and manage your teams in a single
        place
      </div>
      <LBButton size='sm' onClick={redirectToTeamsSettings}>
        Go to settings
      </LBButton>
      <StyledDismiss title='Dismiss'>
        <Icon name='Close' onClick={dismissCTA} />
      </StyledDismiss>
    </StyledSyncTeamsCTA>
  );
};

export default SyncTeamsCTA;
